module.exports = __webpack_public_path__ + "static/img/051 4.e84ab89e.jpg";